import React from 'react'

const IngredientsSubcategory: React.FC = () => (
  <svg width="70" height="71" viewBox="0 0 70 71" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.0769043" width="70" height="70" rx="14.5455" fill="url(#paint0_linear_4461_1544)" />
    <path
      d="M22.7303 22.2029H30.1989C30.749 22.2029 31.195 21.7569 31.195 21.2068C31.195 20.6567 30.749 20.2107 30.1989 20.2107H22.7303C22.1802 20.2107 21.7343 20.6567 21.7343 21.2068C21.7343 21.7569 22.1802 22.2029 22.7303 22.2029Z"
      fill="white"
    />
    <path d="M28.5276 32.8722H32.7953V39.4155H28.5276V32.8722Z" fill="white" />
    <path
      d="M32.7953 41.4076H27.5314C26.9813 41.4076 26.5354 40.9616 26.5354 40.4115V31.8761C26.5354 31.326 26.9813 30.88 27.5314 30.88H32.7945C32.7796 29.1765 32.1095 27.577 30.9031 26.3706C30.2962 25.7638 29.8867 25.0127 29.7038 24.1952H23.2253C23.0424 25.0128 22.6329 25.7638 22.026 26.3706C20.8058 27.5908 20.1338 29.213 20.1338 30.9383V43.6832H32.7953V41.4076Z"
      fill="white"
    />
    <path
      d="M43.6063 31.8761V43.6832H49.8662V31.8761C49.8662 31.7215 49.8302 31.569 49.7611 31.4307L47.7324 27.3733V23.3407C47.7324 22.7906 47.2864 22.3446 46.7363 22.3446C46.1862 22.3446 45.7402 22.7906 45.7402 23.3407V27.3733L43.7115 31.4307C43.6423 31.5689 43.6063 31.7215 43.6063 31.8761Z"
      fill="white"
    />
    <path
      d="M41.9298 30.5394L42.8972 28.6045H36.5891L35.4513 30.88H41.7859C41.8269 30.7636 41.8746 30.6497 41.9298 30.5394Z"
      fill="white"
    />
    <path
      d="M43.7479 23.3407C43.7479 22.9916 43.8087 22.6564 43.9192 22.3446H38.2008C37.6507 22.3446 37.2047 22.7906 37.2047 23.3407V26.6124H43.7479V23.3407Z"
      fill="white"
    />
    <path d="M35.0708 32.8722H41.614V43.6832H35.0708V32.8722Z" fill="white" />
    <path
      d="M51.0039 45.6753H18.9961C18.446 45.6753 18 46.1213 18 46.6714V48.947C18 49.4971 18.446 49.9431 18.9961 49.9431H51.0039C51.554 49.9431 52 49.4971 52 48.947V46.6714C52 46.1213 51.554 45.6753 51.0039 45.6753Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4461_1544"
        x1="34.5455"
        y1="0.0769046"
        x2="34.5455"
        y2="70.0769"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB300" />
        <stop offset="1" stopColor="#E5A100" />
      </linearGradient>
    </defs>
  </svg>
)

export default IngredientsSubcategory
